import { SxProps, Theme } from '@mui/material/styles';
import { BORDER_RADIUS } from '@/theme/tokens';

export interface IOutlinedButtonStyles {
  root: SxProps;
  outlinedButton: SxProps;
}

export const getOutlinedButtonStyles = (
  theme: Theme,
  styleOverrides?: Partial<IOutlinedButtonStyles>,
  gradientOutline?: boolean
) => ({
  root: {
    display: 'inline-block',
    padding: '0.2px',
    borderRadius: BORDER_RADIUS,
    background: gradientOutline
      ? theme.tokens.colors.primary // Using semantic token that maps to gradient
      : theme.tokens.colors.border,
    ...styleOverrides?.root,
  },
  outlinedButton: {
    width: '100%',
    paddingTop: theme.tokens.spacing.buttonPadding,
    paddingBottom: theme.tokens.spacing.buttonPadding,
    color: theme.tokens.colors.textPrimary,
    border: '2px solid transparent',
    fontFamily: theme.tokens.typography.fontFamily,
    fontWeight: theme.tokens.typography.button.fontWeight,
    fontSize: theme.tokens.typography.button.fontSize,
    borderRadius: 'inherit',
    textTransform: theme.tokens.typography.button.textTransform,
    background: theme.tokens.colors.background,
    backgroundClip: 'padding-box',
    boxShadow: 'none',
    position: 'relative',
    zIndex: 1,
    '&:hover': {
      backgroundColor: theme.tokens.colors.hover,
      color: theme.tokens.colors.textOnPrimary,
      borderColor: gradientOutline ? 'transparent' : theme.tokens.colors.border,
    },
  },
});
